import React from "react";
import CenterSection from "./CentralSection";
import RightSection from "./RightSection";
import LeftSection from "./LeftSection";

type Props = {};

const Header = (props: Props) => {
  return (
    <div className="p-4 flex items-center justify-between">
      <LeftSection />

      <CenterSection />

      <RightSection />
    </div>
  );
};

export default Header;
